const items = [
  {
    id: 0,
    title: "What is DDPI?",
    content: `DDPI is a ‘Voluntary Document’. DDPI is an authorization given by the
    clients/investor to the broker. It authorizes brokers to transfer securities to an exchange from their clients' demat accounts. Once the DDPI has been filed, the customer may sell shares without entering the CDSL T-PIN and OTP. `,
  },
  {
    id: 1,
    title: "Is DDPI compulsory?",
    content:"The provision of DDPI is Optional/Voluntary. Clients who have created accounts electronically may approve securities debits using their CDSL TPIN.",
  },
  {
    id: 2,
    title: "Is there any alternative to DDPI?",
    content: `Yes, SEBI said that the customer can either use the DDPI or complete the settlement on their own by providing either a physical Delivery Instruction Slip (DIS) or an electronic Delivery Instruction Slip (eDIS). `,
  },
  {
    id: 3,
    title: "What does DDPI allow to the brokers?",
    content: `This  authorises the stockbrokers to meet obligations on behalf of clients on a day-to-day basis.`,
  },
  // {
  //   id: 4,
  //   title: "What is the Purpose of releasing DDPI by SEBI?",
  //   content: `The primary objective for the development of DDPI was to limit stock brokers
  //     abusing the power of attorney (POA) that their clients had granted them. DDPI would
  //     serve the same function as the POA.`,
  // },
  {
    id: 5,
    title: "What is PoA?",
    content: `PoA or Power of Attorney is a legal document that authorizes brokers/agents/agencies registered with SEBI to meet obligations of the signee.`,
  },
  {
    id: 6,
    title: "What is the relationship between POA and DDPI?",
    content: `DDPI (Demat Debit and Pledge Instruction) replaced PoA from July 1, 2022 onwards.`,
  },
  {
    id: 7,
    title: "What if PoA is already submitted?",
    content: `DDPI does not void previously signed PoAs. Existing clients' PoA authorizations
      would remain in effect. Brokers will only be allowed to request DDPI from new clients
      who have been onboarded from September 1, 2022.`,
  },
  // {
  //   id: 8,
  //   title: "How does DDPI facilitate a paperless agreement?",
  //   content:
  //     "DDPI procedure saves time, space, effort, and paper by signing and submitting DDPI documents to brokers via electronic means i.e. e-sign, e-stamping, and e-verification.",
  // },
];

export default items;
